import * as React from "react";
import queryString from 'query-string';
import EditionService from "../../Services/editionService";
import { Container, Row, Col } from 'reactstrap';
import {Icon, Breadcrumb, Button, Popover, Avatar, Badge, Modal} from 'antd';
import { blobToSRC, downloadFileBlob, formatDate } from "../../util/UtilFunction";
import { FileType } from "../../APIModels/FileParam";
import FileService from "../../Services/fileService";
import {FMKArticlesTable} from "../Articles/FMKArticlesTable";
import ArticleService from "../../Services/articleService";
import {GetArticleParams} from "../../APIModels/GetArticleParams";
import alertService from "../../Services/alertService";
import { OrderParams } from "../../APIModels/BaseParams";

export class DetailEdition extends React.Component {
    constructor(props) {
        super(props)

        let params = queryString.parse(this.props.location.search);
        this.props.showUserBadge(false);
        this.state = {
            user: this.props.token,
            id: params.id,
            edition: null,
            cover: null,
            pdfComplete: null,
            txtComplete: null,
            articles: [],
            paramResponse:null,
            modalOpen: false,
            modalTitle: '',
            modalId: '',
        }

        this.editionService = new EditionService(this.props.token);
        this.articlesService = new ArticleService(this.props.token);
        this.fileService = new FileService(this.props.token);

        this.goToDetail = this.goToDetail.bind(this);
        this.getFile = this.getFile.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.setPagination = this.setPagination.bind(this);
        this.setModal = this.setModal.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.fetchEditionById(this.state.id) 
    }


    fetchEditionById(id) {
        this.props.loader(true)
        this.editionService.getEdition(id)
            .then((response) => {
                this.setState({ edition: response.data.data }, (() => {
                    this.fetchArticlesByEditionId(this.state.id, response.data.data.number, 10, 1)
                    this.getFile()
                } ))
                this.props.loader(false)
            }).catch((err) => {
                console.log(err);
                this.props.loader(false)
            })
    }

    fetchArticlesByEditionId(editionId, editionNumber, size, page){
        this.props.loader(true)
        const param = new GetArticleParams();
        param.editionId = editionId;
        param.editionNumber = editionNumber
        param.pageSize = size
        param.page = page
        param.ordering = new OrderParams();
        param.ordering.orderPropertyName = 'pageFrom';
        localStorage.setItem("params", JSON.stringify(param))
        this.articlesService.getArticleList(param)
            .then((response) => {
                this.setState({ articles: response.data.data, paramResponse: response.data.params })
                this.props.loader(false)
            }).catch((err) => {
            console.log(err);
            this.props.loader(false)
        })
    }

    setPagination(size, page) {
        this.fetchArticlesByEditionId(this.state.edition.id, this.state.edition.number, size, page)
    }

    getFile() {
        let cover = this.state.edition.files.filter(f => f.type == FileType.Cover)[0];
        let pdfComplete = this.state.edition.files.filter(f => f.type == FileType.CompletePdf)[0];
        let txtComplete = this.state.edition.files.filter(f => f.type == FileType.CompleteTxt)[0];

        if (cover) {
            const coverIsPdf = cover.fileName.endsWith(".pdf");
            this.setState({ cover: cover})
            this.fileService.downloadFile(cover.id)
                .then(resp => {
                    let base64 = '';
                    let reader = blobToSRC(resp.data, coverIsPdf ? 'application/pdf' : 'image/jpg')
                    reader.onloadend = function () {
                        base64 = reader.result;
                        if(coverIsPdf){
                            document.getElementById("coverPDF").setAttribute('src', base64 + "#toolbar=0&zoom=0")
                            document.getElementById("coverImg").style.display = 'none';
                        }else{
                            document.getElementById("coverImg").setAttribute('src', base64);
                            document.getElementById("coverPDF").style.display = 'none';
                        }
                    }
                })
        }

        if (pdfComplete)
            this.setState({ pdfComplete: pdfComplete })

        if (txtComplete)
            this.setState({ txtComplete: txtComplete })
    }

    downloadFile(f) {
        let file
        let type
        if (f === "cover") {
            file = this.state.cover;
            type = "image/jpg"
        }
        if (f === "pdfComplete") {
            file = this.state.pdfComplete;
            type = "application/pdf"
        }
        if (f === "txtComplete") {
            file = this.state.txtComplete;
            type = "txtComplete"
        }

        if (file) {
            this.fileService.downloadFile(file.id).then(resp => {
                downloadFileBlob(resp.data, file.fileName, type)
            })
        }
    }


    deleteEdition(id) {
        this.editionService.deleteEdition(id)
            .then((response) =>  {
               if(response.data && response.data.ok){
                    alertService.setAlert('success', 'Edition delete');
                    window.open("/archive","_self");
               }
            })
            .catch((err) => console.log(err))
    }

    goToDetail() {
        window.open("/archive/edition/detail?id=" + this.state.edition.parentEditionAttachmentTypeId, "_self")
    }

    goBack() {
        if(document.referrer) //exist prev url
            return window.history.back()
        else
            return window.open("/archive", '_self');
    }


    setModal(value, title, id) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id })
    }

    handleOk(id) {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
        this.deleteEdition(id)
    }

    handleCancel() {
        this.setState({ modalOpen: false, modalTitle: '', modalId: null })
    }

    render() {
        let modal =
            <Modal title={'Delete edition n° ' + this.state.modalTitle} visible={this.state.modalOpen} onOk={() => this.handleOk(this.state.modalId, this.state.modalTitle)} onCancel={() => this.handleCancel()}>
                <p>Delete edition number: {this.state.modalTitle}?</p>
            </Modal>

        return (this.state.edition &&
            <Container fluid={true}>
                <Row style={{minHeight: 'unset'}}>
                    <Col sm="12" style={{display: 'inline-flex', height: '0', justifyContent: "end"}}>
                        <Breadcrumb className="bread" style={{left: 24}}>
                            <Breadcrumb.Item>
                                <Button className="fmk_button primary mr-2" style={{bottom: 3}} onClick={() => this.goBack()}>
                                    <Icon type="caret-left" />
                                </Button>
                                <strong className="h5 font-weight-bold" style={{color: 'black'}}>View edition</strong>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <Badge>
                                <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                                    <div style={{cursor: 'pointer'}}>
                                        <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}}
                                                icon="user"/>
                                    </div>
                                </Popover>
                            </Badge>
                        </div>
                    </Col>
                    <Col sm='12'>
                        <div className="wizardFields wizardContacts mt-4 p-0">
                            <div className="wizardBackground createCat">
                                <div className="modifyHrBox" style={{ width: '100%' }}>
                                    <Row>
                                        {this.state.cover &&
                                            <Col sm="12" md="2">
                                                <img id="coverImg" className="coverEdition"/>
                                                <iframe id="coverPDF" className="coverEdition" style={{ height: 260, maxWidth: 280 }} frameBorder="0"></iframe>
                                            </Col>
                                        }
                                        <Col sm="12" md="6">
                                        <h3>Edition n° {this.state.edition.number}</h3>
                                            <p className="lead" style={{ marginBottom: "0.5em" }}>{this.state.edition.description}</p>
                                            <p>Magazine: <strong>{this.state.edition.magazine.name}</strong></p>
                                            <p>Competence from: <strong>{formatDate(this.state.edition.competenceDateFrom, 'MMMM YYYY')}</strong> to <strong>{formatDate(this.state.edition.competenceDateTo, 'MMMM YYYY')}</strong></p>
                                            {this.state.edition.parentEditionAttachmentType &&
                                                <p>Attachment: <strong className="fakeLink" onClick={this.goToDetail}>{this.state.edition.parentEditionAttachmentType.number}</strong></p>
                                            }
                                        </Col>
                                        <Col sm="12" md="4">
                                            <p className="h5 font-weight-bold mt-2" style={{color: 'black'}}>Details</p>
                                            <div className="d-flex align-items-center my-4">
                                                <p style={{width: 100}}><strong>Cover edition:</strong></p>
                                                <Button disabled={!this.state.cover}
                                                        className="ml-3 fmk_button secondary"
                                                        onClick={() => this.downloadFile("cover")}> <Icon
                                                    type="download"/> Download</Button>
                                            </div>
                                            <div className="d-flex align-items-center my-4">
                                                <p style={{width: 100}}><strong>Pdf edition:</strong></p>
                                                <Button disabled={!this.state.pdfComplete}
                                                        className="ml-3 fmk_button secondary"
                                                        onClick={() => this.downloadFile("pdfComplete")}> <Icon
                                                    type="download"/> Download</Button>
                                            </div>
                                            <div className="d-flex align-items-center my-4">
                                                <p style={{width: 100}}><strong>Txt edition:</strong></p>
                                                <Button disabled={!this.state.txtComplete}
                                                        className="ml-3 fmk_button secondary"
                                                        onClick={() => this.downloadFile("txtComplete")}> <Icon
                                                    type="download"/> Download</Button>
                                            </div>

                                            <a className="fmk_button secondary mt-4"
                                               href={"/archive/edition/edit?id=" + this.state.edition.id}>
                                                <Icon type="edit" className="mx-2"/>
                                                Edit edition
                                            </a>

                                            <button className="fmk_button secondary mt-4 ml-2"
                                                    onClick={(e) => this.setModal(true, this.state.edition.number, this.state.edition.id)}>
                                                <Icon type="delete" className="mx-2"/>
                                                Delete edition
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row style={{minHeight: 'unset'}}>
                    <Col sm="12" className="pt-4" >
                        <div className="wizardFields wizardContacts p-0">
                            <FMKArticlesTable articles={this.state.articles}
                                              showCheckbox={false}
                                              showActions={false}
                                              isEditionPage={true}
                                              paramResponse={this.state.paramResponse}
                                              setPagination={this.setPagination}
                                              selectedRow={[]}>
                            </FMKArticlesTable>
                        </div>
                    </Col>
                </Row>

                {modal}
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/DetailEdition.js